import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  PLATFORM_ID,
  type OnInit,
} from '@angular/core'
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { SimplebarAngularModule } from 'simplebar-angular'
import { NgbCollapse, NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap'
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { MENU_ITEMS, MenuItemType } from '../../common/menu-meta'
import { basePath } from '../../common/constants'
import { findAllParent, findMenuItem } from '../../helper/utils'
import { LogoBoxComponent } from '../logo-box/app-logo-box';
import { GlobalService } from '../../services/common/global.service';
import { SidebarSearchComponent } from "../sidebar-search/sidebar-search.component";
import { GlobalDataService } from '../../services/global/global-data.service';
import { localStorageKeys } from '../../common/localstorages';
import { RouteUtils } from '../../services/utils/route-utils';
@Component({
  selector: 'app-sidebar',
  imports: [SimplebarAngularModule, NgbCollapseModule, RouterModule,
     LogoBoxComponent, CommonModule, SidebarSearchComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css'
})
export class SidebarComponent {
  menuItems: MenuItemType[] = []
  activeMenuItems: string[] = []
  globalService = inject(GlobalService);
  
  router = inject(Router)
  trimmedURL = this.router.url?.replaceAll(
    basePath !== '' ? basePath + '/' : '',
    '/'
  )
private platformId = inject(PLATFORM_ID);
    private isBrowser: boolean = isPlatformBrowser(this.platformId);
  
  // store = inject(Store);
  userType:string=""
  practiceValue!:number;
  constructor() {
    this.userType = this.globalService.getUserRole();
    this.router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this.trimmedURL = this.router.url?.replaceAll(
          basePath !== '' ? basePath + '/' : '',
          '/'
        )
        this._activateMenu()
        setTimeout(() => {
          this.scrollToActive()
        }, 200)
      }
    })
  }

    isSidebarOpen: boolean = true;

   closeSidebar() {
    // Remove sidebar by toggling class and removing backdrop if present
    if (this.isBrowser) {
      document.documentElement.classList.remove('sidebar-enable');
      const backdrop = document.querySelector('.offcanvas-backdrop');
      if (backdrop) {
        backdrop.parentNode?.removeChild(backdrop);
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
      }
    }
    this.isSidebarOpen = false;
  }
  
  userSetting:any;
  ngOnInit(): void {
    this.userSetting = JSON.parse(this.globalService.getUserSettings());
    this.menuItems = RouteUtils.initMenu(this.globalService.getUserRole(),JSON.parse(this.globalService.getUserSettings()))
    // Automatically navigate to the first sidebar link if not already on a valid sidebar route
    // if (this.menuItems.length > 0) {
    //   // Find the first menu item with a valid route
    //   let firstMenu = this.menuItems[0];
    //   // If it has children, use the first child
    //   if (firstMenu.children && firstMenu.children.length > 0) {
    //     firstMenu = firstMenu.children[0];
    //   }
    //   // Only navigate if not already on the first menu's route
    //   if (firstMenu.route && this.router.url !== firstMenu.route) {
    //     this.router.navigate([firstMenu.route]);
    //   }
    // }
  }

 
  
  //added the logic to show practice cildren
  onPracticeSelected(practiceId: string): void {
    if (practiceId) {
      this.menuItems = this.menuItems.map((item) => {
        if (item.label === 'Practice Panel') {
          return { ...item, showChildren: true };
        }
        return item;
      });
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this._activateMenu()
    })
    setTimeout(() => {
      this.scrollToActive()
    }, 200)
  }

  hasSubmenu(menu: MenuItemType): boolean {
    return menu.children ? true : false
  }

  scrollToActive(): void {
    if (this.isBrowser) {
    const activatedItem = document.querySelector('.side-nav-item li a.active')
    if (activatedItem) {
      const simplebarContent = document.querySelector(
        '.sidenav-menu .simplebar-content-wrapper'
      )
      if (simplebarContent) {
        const activatedItemRect = activatedItem.getBoundingClientRect()
        const simplebarContentRect = simplebarContent.getBoundingClientRect()
        const activatedItemOffsetTop =
          activatedItemRect.top + simplebarContent.scrollTop
        const centerOffset =
          activatedItemOffsetTop -
          simplebarContentRect.top -
          simplebarContent.clientHeight / 2 +
          activatedItemRect.height / 2
        this.scrollTo(simplebarContent, centerOffset, 600)
      }
    }
  }
  }

  easeInOutQuad(t: number, b: number, c: number, d: number): number {
    t /= d / 2
    if (t < 1) return (c / 2) * t * t + b
    t--
    return (-c / 2) * (t * (t - 2) - 1) + b
  }

  scrollTo(element: Element, to: number, duration: number): void {
    const start = element.scrollTop
    const change = to - start
    const increment = 20
    let currentTime = 0

    const animateScroll = () => {
      currentTime += increment
      const val = this.easeInOutQuad(currentTime, start, change, duration)
      element.scrollTop = val
      if (currentTime < duration) {
        setTimeout(animateScroll, increment)
      }
    }
    animateScroll()
  }

  _activateMenu(): void {
    if (this.isBrowser) {
    const div = document.querySelector('.sidenav-menu')
    
    const userType = localStorage.getItem('user-type');
    let matchingMenuItem = null

    if (div) {
      let items: any = div.getElementsByClassName('nav-link-ref')
      for (let i = 0; i < items.length; ++i) {
        if (
          this.trimmedURL === items[i].pathname ||
          (this.trimmedURL.startsWith('/invoice/') &&
            items[i].pathname === '/invoice/RB6985') ||
          (this.trimmedURL.startsWith('/ecommerce/product/') &&
            items[i].pathname === '/ecommerce/product/1')
        ) {
          matchingMenuItem = items[i]
          break
        }
      }

      if (matchingMenuItem) {
        const mid = matchingMenuItem.getAttribute('aria-controls')
        const activeMt = findMenuItem(this.menuItems.filter(x=>{
          x.key == userType
        }), mid)

        if (activeMt) {
          const matchingObjs = [
            activeMt['key'],
            ...findAllParent(this.menuItems, activeMt),
          ]

          this.activeMenuItems = matchingObjs
          this.menuItems.forEach((menu: MenuItemType) => {
            menu.collapsed = !matchingObjs.includes(menu.key!)
          })
        }
      }
    }
  }
  }

  /**
   * toggles open menu
   * @param menuItem clicked menuitem
   * @param collapse collpase instance
   */
  toggleMenuItem(menuItem: MenuItemType, collapse: NgbCollapse): void {
    collapse.toggle()
    let openMenuItems: string[]
    if (!menuItem.collapsed) {
      openMenuItems = [
        menuItem['key'],
        ...findAllParent(this.menuItems, menuItem),
      ]
      this.menuItems.forEach((menu: MenuItemType) => {
        if (!openMenuItems.includes(menu.key!)) {
          menu.collapsed = true
        }
      })
    }
  }

  /**
   * Save screenId to localStorage when a menu item is clicked
   */
  onMenuItemClick(menu: any): void {
     if (this.router.url === menu.url) {
      window.location.reload();
      return;
    }
    if (menu && menu.screenId) {
      localStorage.setItem('active-screen-id', menu.screenId);
      localStorage.setItem('screen-name', menu.screenName);
    }
  }
}
